import { render } from "./VignetteComponent.vue?vue&type=template&id=badd28da&scoped=true"
import script from "./VignetteComponent.vue?vue&type=script&lang=js"
export * from "./VignetteComponent.vue?vue&type=script&lang=js"

import "./VignetteComponent.vue?vue&type=style&index=0&id=badd28da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badd28da"]])

export default __exports__